var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeBotAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_1814_122976)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9033 21.8258C21.9051 20.6203 22.2642 19.4425 22.9352 18.441C23.6063 17.4396 24.5591 16.6595 25.6733 16.1994C26.7876 15.7393 28.0132 15.6199 29.1953 15.8562C30.3774 16.0925 31.4629 16.6738 32.3147 17.5269C33.1664 18.3799 33.7462 19.4663 33.9807 20.6487C34.2153 21.8312 34.094 23.0566 33.6323 24.1702C33.1705 25.2837 32.3891 26.2354 31.3866 26.9049C30.3842 27.5745 29.2058 27.9318 28.0003 27.9318C27.199 27.9312 26.4057 27.7728 25.6657 27.4657C24.9256 27.1585 24.2534 26.7085 23.6872 26.1416C23.121 25.5746 22.6721 24.9016 22.366 24.1611C22.06 23.4206 21.9027 22.6271 21.9033 21.8258Z",
    fill: "#1D1B18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6147 31.4195C34.2426 30.0454 32.3809 29.2726 30.439 29.2711H25.5615C23.6196 29.2726 21.7579 30.0454 20.3858 31.4195C19.0137 32.7936 18.2437 34.6565 18.2451 36.5984V38.3338C18.2447 38.8447 18.4473 39.3349 18.8083 39.6964C19.1692 40.058 19.659 40.2615 20.1699 40.262H35.8306C36.3415 40.2615 36.8313 40.058 37.1923 39.6964C37.5533 39.3349 37.7558 38.8447 37.7554 38.3338V36.5984C37.7568 34.6565 36.9868 32.7936 35.6147 31.4195ZM27.6869 37.5156L31.7629 33.4396C31.8588 33.3475 31.9351 33.237 31.9873 33.1147C32.0394 32.9924 32.0662 32.8608 32.0662 32.7279C32.0662 32.5949 32.0394 32.4634 31.9873 32.3411C31.9351 32.2188 31.8588 32.1082 31.7629 32.0162C31.573 31.8296 31.3175 31.725 31.0513 31.725C30.785 31.725 30.5295 31.8296 30.3396 32.0162L26.9752 35.3805L25.6488 34.0542C25.4593 33.8692 25.2045 33.7664 24.9397 33.768C24.6748 33.7696 24.4213 33.8755 24.2341 34.0628C24.0468 34.2501 23.9409 34.5036 23.9393 34.7684C23.9376 35.0333 24.0405 35.2881 24.2255 35.4776L26.2635 37.5156C26.4568 37.6969 26.7102 37.8006 26.9752 37.8068C27.1071 37.8075 27.2379 37.7821 27.36 37.7321C27.4822 37.6822 27.5932 37.6086 27.6869 37.5156Z",
    fill: "#1D1B18"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1814_122976",
    x1: 0,
    y1: 28.002,
    x2: 56,
    y2: 28.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBotAccount);
export default __webpack_public_path__ + "static/media/Home_Bot_Account.7a1059e37fc51002935b14bc17e95d72.svg";
export { ForwardRef as ReactComponent };